import { CursorTip } from '../extensions/cursor-tip';
import { GlobalMask } from '../extensions/global-mask';
import { HoverExtend } from '../extensions/hover-extend';
import { StageScroll } from '../extensions/scroll-to';
import { ShortcutMenu } from '../extensions/shortcut-menu';
import { OperateData } from './operate-data';

export class OperateServer extends OperateData {
    /** 光标提示 */
    cursorTip: CursorTip;
    /** 全局遮罩 */
    globalMask: GlobalMask;
    /** 图层快捷操作菜单 */
    shortcutMenu: ShortcutMenu;
    /** hover扩展 */
    hoverExtend: HoverExtend;
    /** 舞台滚动 */
    stageScroll: StageScroll;

    constructor(identity: string) {
        super(identity);
        this.cursorTip = new CursorTip(identity);
        this.globalMask = new GlobalMask(identity);
        this.shortcutMenu = new ShortcutMenu(identity);
        this.hoverExtend = new HoverExtend(identity);
        this.stageScroll = new StageScroll(identity);
    }

    destroy() {
        super.destroy();
        this.hoverExtend.destroy();
    }
}
